<script lang="ts">
	import { twMerge } from 'tailwind-merge';
	import { AdvertImpressionTracker } from '#lib/features/adverts/AdvertImpressionTracker/index.js';
	import { NewsAdvertMixpanelEvents } from '#lib/features/news/constants/mixpanel-events.js';
	import { Txt } from '$global/components/Txt';
	import { track } from '$global/utils/track';

	interface Props {
		feedIndexNumber: number;
		classes?: {
			container?: string;
		};
	}

	let { classes, feedIndexNumber }: Props = $props();

	const MAX_IMPRESSIONS = 2;
	const AD_ID = '1001'; // tbc

	const dataCyPrefix = 'news-jha-advert-card';

	const title = 'Need an art lawyer?';

	const description1 = `At JHA Law we have the leading art law team giving practical advice across all sectors of the art market.`;

	const description2 = `Our team has decades of experience working with clients ranging from many of the most important artists (and estates) of our time to leading collectors, advisors, museums, auction houses and other participants in the market.`;

	const href = 'https://l.heni.com/ad1';

	const handleClick = () => {
		track(NewsAdvertMixpanelEvents.JhaClick, {
			feed_idx: feedIndexNumber,
			href,
			ad_id: AD_ID,
		});
	};
</script>

<AdvertImpressionTracker
	storageKey={NewsAdvertMixpanelEvents.JhaImpression}
	maxImpressions={MAX_IMPRESSIONS}
	trackProperties={{ feed_idx: feedIndexNumber, href, ad_id: AD_ID }}
>
	<a
		{href}
		target="_blank"
		rel="noopener noreferrer"
		onclick={handleClick}
		data-cy={dataCyPrefix}
		class={twMerge('block', classes?.container)}
	>
		<div class="rounded border-b bg-white sm:border">
			<div class="w-full overflow-hidden">
				<img
					src="/img-svelte/jha.png"
					alt={title}
					class="h-full w-full object-cover"
					data-cy={`${dataCyPrefix}-image`}
				/>
			</div>

			<div class="px-6 py-4">
				<Txt
					variant="h5"
					data-cy={`${dataCyPrefix}-title`}
					class="mb-4 text-center font-[600] text-[#53150F]"
				>
					{title}
				</Txt>

				<Txt variant="body2" class="mb-6 text-center">
					{description1}
				</Txt>

				<Txt variant="body2" class="mb-6 text-center">
					{description2}
				</Txt>

				<button
					class="font-silka m-auto mb-6 block h-[36px] w-[160px] rounded-md bg-[#53150F] px-4 text-[14px] text-white"
					data-cy={`${dataCyPrefix}-button`}
				>
					Learn More
				</button>

				<Txt variant="body3" class="text-center text-[#53150F] opacity-50">
					— Sponsored Link —
				</Txt>
			</div>
		</div>
	</a>
</AdvertImpressionTracker>
